import { useEffect, useState, useRef, useMemo } from 'react';
import { Card, Row, Col, Form, Button, Select, Input } from 'antd';
import { useHistory, useLocation } from "react-router-dom";
import { headerStyle, rowStyle } from 'shared/styles/baseStyle';
import  EndPoints from 'shared/endPoints/EndPoints.json';
import  Validations from 'shared/validations/Validations.json';
import DeviceOverviewResults from './DeviceOverviewResults';

import './deviceOverview.css'

export default function DeviceOverview() {
    const history = useHistory();
    const { search } = useLocation()
    const queryParams = useMemo(() => new URLSearchParams(search), [search])
    const [endPoint, setEndPoint] = useState()
    const myRef = useRef();
    const [form] = Form.useForm();
    const { Option } = Select;

    const layout = {
        labelCol: {
            span: 6,
        },
        wrapperCol: {
            span: 12,
        },
    };

    const statusOptions = [
        {
            key: null,
            name: 'Όλες'
        },
        {
            key: '1',
            name: 'New'
        },
        {
            key: '2',
            name: 'Reset'
        }
    ]

    const executeScroll = () => myRef.current.scrollIntoView({ behavior: 'smooth' });

    const onFinish = (fieldsValues) => {
        
        const values = {
            ...fieldsValues
        }
        Object.keys(values).forEach(key => values[key] === null || values[key] === undefined || values[key] === '' ? delete values[key] : values[key]);
        const params = new URLSearchParams(values);
        history.replace({ search: `?${params}` });
        setEndPoint(`${EndPoints.PACKING.GETPACKINGOVERVIEW}?${params}`);
        executeScroll();
    }

    useEffect(() => {
        form.setFieldsValue({
            'Status': queryParams.get('Status'),
            'Imei': queryParams.get('Imei'),
        })
        setEndPoint(`${EndPoints.PACKING.GETPACKINGOVERVIEW}?${queryParams.toString()}`);
    }, [queryParams, form])
    const statusPacking = statusOptions.find(opt => opt.key === queryParams.get('Status'))
    return (
        <>
            <Card type="inner" headStyle={headerStyle} title="Συμπληρώστε οποιοδήποτε από τα πεδία και στη συνέχεια πατήστε το κουμπί Αναζήτηση">
                <Row style={rowStyle}>
                    <Col style={{ color: 'black' }} span={24}>Κριτήρια Αναζήτησης</Col>
                </Row>
                <Form form={form} onFinish={onFinish} {...layout} >
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                name="Status"
                                label="Κατάσταση"
                            >
                                <Select>
                                    {statusOptions.map(status =>
                                        <Option key={status.key} value={status.key}>{status.name}</Option>
                                    )}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="Imei"
                                label="ΙΜΕΙ Συσκευής:"
                                rules={[
                                    {
                                        pattern: new RegExp(Validations.DEVICEIMEI.REGEX),
                                        message: Validations.DEVICEIMEI.MESSAGE
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={8} offset={10} >
                            <Form.Item >
                                <Button htmlType="submit" style={{ backgroundColor: '#e6e6e6' }} >
                                    Αναζήτηση
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Col ref={myRef}>
                <Col className=".ant-col-offset-1" offset={1} style={{position: 'absolute'}}>{statusPacking.name}</Col>
                <DeviceOverviewResults endPoint={endPoint} />
            </Col>
        </>
    );
}